var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../context/ThemeContext';
var BackgroundLayout = function (_a) {
    var children = _a.children;
    var theme = useTheme().theme;
    // Simple background colors based on theme
    var backgroundClass = theme === 'dark'
        ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900'
        : 'bg-gradient-to-br from-gray-50 via-white to-gray-100';
    return (_jsx("div", __assign({ className: "min-h-screen ".concat(backgroundClass) }, { children: children })));
};
export default BackgroundLayout;
